module.exports = __webpack_public_path__ + "static/img/IMG_20150823_111845.e7f2a17a.jpg";